/**
 * AlgorithmCard Component
 * Displays algorithm summary in the grid
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useBookmarks } from '../../hooks';
import './AlgorithmCard.css';

function AlgorithmCard({ algorithm }) {
  const { isBookmarked, toggle } = useBookmarks();
  const bookmarked = isBookmarked(algorithm.id);

  return (
    <div className="algo-card card card-clickable">
      {/* Header */}
      <div className="algo-card-header">
        <div className="algo-card-meta">
          <span className={`badge badge-${algorithm.difficulty?.toLowerCase()}`}>
            {algorithm.difficulty}
          </span>
          <span className="badge badge-accent">{algorithm.unit}</span>
        </div>
        <button
          className={`bookmark-btn ${bookmarked ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); toggle(algorithm.id); }}
          aria-label={bookmarked ? 'Remove bookmark' : 'Add bookmark'}
        >
          {bookmarked ? '★' : '☆'}
        </button>
      </div>

      {/* Title */}
      <h3 className="algo-card-title">{algorithm.name}</h3>
      <p className="algo-card-full-name">{algorithm.fullName}</p>

      {/* Description */}
      <p className="algo-card-desc">{algorithm.description}</p>

      {/* Complexity */}
      <div className="algo-card-complexity">
        <div>
          <span className="complexity-label">Time</span>
          <span className="complexity-badge">{algorithm.timeComplexity?.average}</span>
        </div>
        <div>
          <span className="complexity-label">Space</span>
          <span className="complexity-badge">{algorithm.spaceComplexity}</span>
        </div>
      </div>

      {/* Tags */}
      <div className="algo-card-tags">
        {algorithm.tags?.slice(0, 3).map(tag => (
          <span key={tag} className="tag">#{tag}</span>
        ))}
      </div>

      {/* Action */}
      <Link
        to={`/algorithms/${algorithm.id}`}
        className="algo-card-link"
      >
        Explore Algorithm →
      </Link>
    </div>
  );
}

export default AlgorithmCard;
